import { Component } from 'react';
import ReactTable from 'react-table';
import { compose } from 'recompose';
// core components
import TableActions from 'components/DataTable/Actions';
import Danger from 'components/Typography/Danger';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core/index';
import withStyles from '@material-ui/core/styles/withStyles';
import { Help, FormatListBulleted, ListAlt } from '@material-ui/icons';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';
import { toast } from 'react-toastify';

const styles = {
  table: {
    '& .rt-thead .rt-th': {
      color: grayColor[1],
      fontSize: '12px',
      fontWeight: 400,
      textAlign: 'left',
      padding: '0 8px 8px',
      boxShadow: 'none',
    },
    '& .rt-tbody .rt-td': {
      display: 'flex',
      alignItems: 'center',
      minHeight: '40px',
      padding: '0 8px',
      fontSize: '14px',
      color: grayColor[2],
    },
    '& .rt-tbody .rt-tr-group': {
      borderBottom: 'none',
    },
    '& .rt-noData': {
      color: grayColor[1],
      fontSize: '14px',
      background: 'transparent',
    },
  },
};

class IngredientsRecipesTable extends Component {
  renderIngredients = () =>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
    this.props.data.map((item, ingredientIndex) => {
      const isRecipe = item.recipe !== null;
      const currentItem = isRecipe ? item.recipe : item.ingredient;
      const glycemicIndex = currentItem?.macrosAfterProcessing?.glycemicIndex;
      const ingredientNoGlycemicIndex = glycemicIndex === null;
      const { t } = this.props;
      const glycemicIndexValue = () => {
        if (ingredientNoGlycemicIndex) {
          const translateText = isRecipe
            ? t('glycemicIndex.recipeIngredientNoIG')
            : t('glycemicIndex.ingredientNoIG');

          return (
            <Tooltip title={translateText}>
              <Help
                style={{
                  fontSize: '16px',
                  color: 'grey',
                }}
              />
            </Tooltip>
          );
        }

        return glycemicIndex;
      };

      const getNutritionalValue = (type, unit) => {
        const value = currentItem?.macrosAfterProcessing?.[type];

        if (value !== null) {
          const parsedValue = isRecipe
            ? (
                (parseFloat(value) /
                  parseFloat(currentItem.macrosAfterProcessing.weight)) *
                100
              ).toFixed(2)
            : parseFloat(value).toFixed(2);

          return `${parsedValue} ${unit}`;
        }
        return '-';
      };

      if (currentItem?.['@type'] === 'Ingredient' && !currentItem?.unit) {
        toast.error(this.props.t('form.ingredientsDetails.unitHasBeenRemoved'));
      }

      return {
        workName: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '10px',
            }}
          >
            <TableActions handleRemove={() => this.props.handleRemove(item)} />
            <span style={{ margin: '0 5px 0 -15px', color: '#888888' }}>
              {currentItem?.['@type'] === 'Ingredient' && (
                <FormatListBulleted fontSize="small" />
              )}
              {currentItem?.['@type'] === 'Recipe' && <ListAlt />}
            </span>
            <NavLink
              target="_blank"
              to={`/admin/${
                currentItem?.['@type'] === 'Ingredient'
                  ? 'ingredients'
                  : 'recipes'
              }/edit/${currentItem?.id}`}
            >
              {currentItem.workName ? currentItem.workName : currentItem.name}
            </NavLink>

            {currentItem?.macrosAfterProcessing?.calories === null && (
              <Tooltip
                title={this.props.t(
                  'meals.dishIngredients.recalculationProgress'
                )}
              >
                <Help
                  style={{
                    fontSize: '16px',
                    color: 'grey',
                    marginLeft: '4px',
                  }}
                />
              </Tooltip>
            )}
          </div>
        ),
        // 😢
        unit:
          // eslint-disable-next-line no-nested-ternary -- FIXME
          currentItem['@type'] === 'Ingredient' ? (
            // eslint-disable-next-line no-nested-ternary -- FIXME
            currentItem.unit ? (
              currentItem.unit.value ? (
                currentItem.unit.value
              ) : (
                currentItem.unit
              )
            ) : (
              <Danger>
                <b>{this.props.t('form.ingredientsDetails.noUnit')}</b>
              </Danger>
            )
          ) : (
            'Porcja'
          ),
        glycemicIndex: glycemicIndexValue(),
        weight: `${(currentItem.macrosAfterProcessing.weight || 0).toFixed(
          2
        )} g`,
        calories: getNutritionalValue('calories', 'kcal'),
        protein: getNutritionalValue('protein', 'g'),
        fat: getNutritionalValue('fat', 'g'),
        carbohydrates: getNutritionalValue('carbohydrates', 'g'),
        roughage: getNutritionalValue('roughage', 'g'),
      };
    });

  render() {
    const { t } = this.props;
    const columns = [
      {
        Header: t('form.ingredientsDetails.workingName'),
        accessor: 'workName',
        width: 350,
      },
      {
        Header: t('form.ingredientsDetails.unit'),
        accessor: 'unit',
      },
      /* {
        Header: 'WpO',
        accessor: 'weight',
      }, */
      {
        Header: t('glycemicIndex.shortLabel'),
        accessor: 'glycemicIndex',
      },
      {
        Header: t('form.ingredientsDetails.calories'),
        accessor: 'calories',
      },
      {
        Header: t('form.ingredientsDetails.protein'),
        accessor: 'protein',
      },
      {
        Header: t('form.ingredientsDetails.carbohydrates'),
        accessor: 'carbohydrates',
      },
      {
        Header: t('form.ingredientsDetails.fat'),
        accessor: 'fat',
      },
      {
        Header: t('form.ingredientsDetails.fiber'),
        accessor: 'roughage',
      },
    ];

    return (
      <ReactTable
        data={this.renderIngredients()}
        resizable={false}
        sortable={false}
        columns={columns}
        minRows={3}
        showPaginationTop={false}
        showPaginationBottom={false}
        className={`-striped -highlight ${this.props.classes.table}`}
        noDataText={t('form.field.addIngredientsOrRecipes')}
      />
    );
  }
}

export default compose(
  withTranslation(),
  withStyles(styles)
)(IngredientsRecipesTable);
